import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StockRecommendationRoutingModule } from './stock-recommendation-routing.module';
import { DetailComponent } from './detail/detail.component';
import { HomeComponent } from './home/home.component';
import { SharedModule } from '../shared/shared.module';
import { StockRecommendationComponent } from './stock-recommendation.component';
import { MonthlyComponent } from './monthly/monthly.component';
import { WeeklyComponent } from './weekly/weekly.component';
import { YearlyComponent } from './yearly/yearly.component';
import { DailyComponent } from './daily/daily.component';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { httpTranslateLoader } from '../core/core.module';
import { HttpClient } from '@angular/common/http';
import { StockRecommendationBrokerageFirmComponent } from './stock-recommendation-brokerage-firm/stock-recommendation-brokerage-firm.component';


@NgModule({
  declarations: [
    DetailComponent,
    HomeComponent,
    StockRecommendationComponent,
    MonthlyComponent,
    WeeklyComponent,
    YearlyComponent,
    DailyComponent,
    StockRecommendationBrokerageFirmComponent
  ],
  imports: [
    CommonModule,
    StockRecommendationRoutingModule,
    SharedModule,
    RouterModule,
    FormsModule,
    NgbModule,
    ReactiveFormsModule,
    SharedModule,
    TranslateModule.forChild({
      loader: {
      provide: httpTranslateLoader,
      useFactory: httpTranslateLoader,
      deps: [HttpClient]
    },
    isolate: false
    }),
  ]
})
export class StockRecommendationModule { }
